import React from 'react';
import PropTypes from 'prop-types';
import Page from 'components/widgets/Route';
import Summary from './container/Summary';

const SummaryRoute = ({ match: { path } }) => (
	<Page>
		<Page.Route exact path={path} component={Summary} />
	</Page>
);

SummaryRoute.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	}).isRequired
};

export default SummaryRoute;
